export * from './lang_1033';

export const NEGATIVE_PRACTICES = ['離職意向', 'バーンアウト'];

export const INT_TO_LEAVE_TXT = '離職意向';

export const QUES_LEGEND_TYPE_HEATMAP = {
    バーンアウト: 3,
    離職意向: 3,
    組織の他者への推奨: 2,
    'eNPS(従業員ネットプロモータースコア)': 2,
};

export const QUES_LEGEND_TYPE_DEEP_DIVE = {
    バーンアウト: 2,
    離職意向: 2,
};
